// Function to parse and clean tuition fees

export const parseTuitionFees = (feeString) => {
  if (!feeString || typeof feeString !== "string" || feeString === "N/A") {
    return 0;
  }
  const numericValue = feeString.replace(/[^0-9]/g, ""); // Extract numbers
  return parseInt(numericValue, 10) || 0; // Convert to integer, default to 0 if NaN
};

// Function to handle different column names for Canada and USA
export const transformUniversityData = (uni, country) => {
  const commonFields = {
    name: uni["University Name"] || "N/A",
    country: country,
    tuitionFees: parseTuitionFees(uni["Tution Fees"]),
    livingExpenses: uni["Living Expenses"] || "N/A",
    averageGMAT: uni["Average GMAT score"] || "N/A",
    averageGRE: uni["Average GRE score"] || "N/A",
    averageToefl: uni["Average Toefl Score"] || "N/A",
    averageIelts: uni["Minimum Ielts Score Required"] || "N/A",
    averageGpa: uni["Average Gpa "]?.trim() || "N/A", // Trim space from key name
    averageSalary: uni["Average Salary"] || "N/A",
    acceptanceRate: uni["Acceptance rate"] || "N/A",
    malePercentage: uni["Male percentage"] || "N/A",
    femalePercentage: uni["Female Percentage"] || "N/A",
    internationalStudents: uni["International Students"] || "N/A",
    totalEnrolled: uni["Total Enrolled"] || "N/A",
    verbalReasoning: uni["Verbal Reasoning"] || "N/A",
    quantitativeReasoning: uni["Quantitative Reasoning"]?.trim() || "N/A", // Remove newline if present
    analyticalWriting: uni["Analytical Writing"] || "N/A",
  };

  // Handling USA-specific columns
  if (country === "USA") {
    return {
      ...commonFields,
      greVerbalReasoning: uni["GRE Verbal Reasoning"] || "N/A",
      greAnalyticalWriting: uni["GRE Analytical Writing"] || "N/A",
      greQuantitativeReasoning: uni["GRE Quantitative Reasoning"] || "N/A",
      mastersAcceptanceRate: uni["Master’s Acceptance Rate (%)"] || "N/A",
      phdAcceptanceRate: uni["PhD Acceptance Rate (%)"] || "N/A",
      fellowships: uni["Fellowships"] || "N/A",
      teachingAssistantships: uni["Teaching Assistantships"] || "N/A",
      researchAssistantships: uni["Research Assistantships"] || "N/A",
    };
  }

  // Handling Canada-specific columns (in case you have different column names for Canada)
  if (country === "Canada") {
    return {
      ...commonFields,
      greVerbalReasoning: uni["GRE Verbal Reasoning"] || "N/A", // If applicable for Canada
      greAnalyticalWriting: uni["GRE Analytical Writing"] || "N/A", // If applicable for Canada
      greQuantitativeReasoning: uni["GRE Quantitative Reasoning"] || "N/A", // If applicable for Canada
      fellowships: uni["Fellowships"] || "N/A", // If applicable for Canada
      teachingAssistantships: uni["Teaching Assistantships"] || "N/A", // If applicable for Canada
      researchAssistantships: uni["Research Assistantships"] || "N/A", // If applicable for Canada
    };
  }

  return commonFields;
};
